export default {"src":"/kaimono/_next/static/media/cn_wamazing_stay_h.933affba.svg","height":118,"width":570};